<template>
    <div class="hotel-approve">
        <div class="hotel-approve-container">
            <div class="d-flex">
                <v-btn color="primary" class="ms-auto mb-6" @click="showDrawer = true">
                    <v-icon size="18" class="mr-2">mdi-link-variant</v-icon>
                    Link por e-mail
                </v-btn>
            </div>
            <new-hotels-list/>
            <send-link-to-email :show-dialog="showDrawer" @close="showDrawer = false" onclose="showDrawer = false"/>
        </div>
    </div>
</template>
<script>
import NewHotelsList from "./NewHotelsList.vue";
import SendLinkToEmail from "../../components/Hotel/sendLinkToEmail.vue";

export default {
    name: 'HotelsToApprove',
    components: {
        NewHotelsList,
        SendLinkToEmail,
    },
    data: () => ({
        showDrawer: false
    })
}
</script>

<style lang="scss" scoped>
.hotel-approve {
    background-color: #f0f0f0;
    height: 100%;
    &-container {
        padding: 20px;
        width: 100%;
    }
}

</style>
